// Mock data for Buying Repository & Price Benchmarking

export const mediaProperties = [
  {
    id: 1,
    property: 'MBC 1 - Prime Time',
    channel: 'TV',
    region: 'UAE',
    vendor: 'MBC Group',
    lastPurchasedRate: 850,
    benchmarkedRate: 920,
    variance: -7.6,
    performance: {
      cpm: 12.5,
      grp: 2.8,
      cpe: 0.45
    },
    audienceReach: '2.5M Adults 25-54',
    lastUpdated: '2024-01-15',
    category: 'Entertainment',
    preferredVendor: true,
    availability: 'High'
  },
  {
    id: 2,
    property: 'Google Ads - Search',
    channel: 'Digital',
    region: 'Saudi Arabia',
    vendor: 'Google MENA',
    lastPurchasedRate: 2.85,
    benchmarkedRate: 3.20,
    variance: -10.9,
    performance: {
      cpm: 8.90,
      ctr: 3.2,
      cpc: 2.85
    },
    audienceReach: 'Search Intent Users',
    lastUpdated: '2024-02-01',
    category: 'Search Marketing',
    preferredVendor: true,
    availability: 'High'
  },
  {
    id: 3,
    property: 'Al Khaleej - Full Page',
    channel: 'Print',
    region: 'UAE',
    vendor: 'Al Khaleej Newspapers',
    lastPurchasedRate: 15000,
    benchmarkedRate: 18000,
    variance: -16.7,
    performance: {
      circulation: '150K',
      readership: '450K',
      cpm: 33.3
    },
    audienceReach: '450K Business Professionals',
    lastUpdated: '2024-02-10',
    category: 'Business News',
    preferredVendor: false,
    availability: 'Medium'
  },
  {
    id: 4,
    property: 'Dubai FM - Drive Time',
    channel: 'Radio',
    region: 'UAE',
    vendor: 'Dubai FM Network',
    lastPurchasedRate: 1200,
    benchmarkedRate: 1350,
    variance: -11.1,
    performance: {
      reach: '850K',
      frequency: 3.2,
      cpm: 1.41
    },
    audienceReach: '850K Commuters 25-45',
    lastUpdated: '2024-02-05',
    category: 'Music & Entertainment',
    preferredVendor: true,
    availability: 'Low'
  },
  {
    id: 5,
    property: 'Metro Billboard - Prime',
    channel: 'Outdoor',
    region: 'Qatar',
    vendor: 'Hypermedia Qatar',
    lastPurchasedRate: 45000,
    benchmarkedRate: 52000,
    variance: -13.5,
    performance: {
      impressions: '2M',
      coverage: 'City Wide',
      cpm: 22.5
    },
    audienceReach: '2M Daily Commuters',
    lastUpdated: '2024-02-20',
    category: 'Transit Advertising',
    preferredVendor: false,
    availability: 'Medium'
  },
  {
    id: 6,
    property: 'Facebook - Video Ads',
    channel: 'Digital',
    region: 'Egypt',
    vendor: 'Meta MENA',
    lastPurchasedRate: 4.20,
    benchmarkedRate: 4.80,
    variance: -12.5,
    performance: {
      cpm: 5.60,
      ctr: 2.8,
      vtr: 75
    },
    audienceReach: 'Social Media Users 18-45',
    lastUpdated: '2024-01-25',
    category: 'Social Media',
    preferredVendor: true,
    availability: 'High'
  },
  {
    id: 7,
    property: 'Saudi TV - Ramadan Slots',
    channel: 'TV',
    region: 'Saudi Arabia',
    vendor: 'Saudi Broadcasting',
    lastPurchasedRate: 1250,
    benchmarkedRate: 1450,
    variance: -13.8,
    performance: {
      cpm: 8.30,
      grp: 4.5,
      reach: 85
    },
    audienceReach: '12M Saudi Audience',
    lastUpdated: '2024-01-20',
    category: 'Religious Programming',
    preferredVendor: true,
    availability: 'Seasonal'
  },
  {
    id: 8,
    property: 'Instagram Stories - MENA',
    channel: 'Digital',
    region: 'Kuwait',
    vendor: 'Meta MENA',
    lastPurchasedRate: 6.50,
    benchmarkedRate: 7.20,
    variance: -9.7,
    performance: {
      cpm: 7.80,
      completion: 82,
      engagement: 4.1
    },
    audienceReach: 'Mobile Users 16-35',
    lastUpdated: '2024-02-12',
    category: 'Stories Advertising',
    preferredVendor: true,
    availability: 'High'
  },
  {
    id: 9,
    property: 'Mall Billboard - Central',
    channel: 'Outdoor',
    region: 'Bahrain',
    vendor: 'Gulf Outdoor Media',
    lastPurchasedRate: 28000,
    benchmarkedRate: 32000,
    variance: -12.5,
    performance: {
      footfall: '500K',
      dwell: '45min',
      cpm: 56
    },
    audienceReach: '500K Mall Visitors',
    lastUpdated: '2024-02-08',
    category: 'Retail Advertising',
    preferredVendor: false,
    availability: 'Medium'
  },
  {
    id: 10,
    property: 'YouTube Pre-Roll - MENA',
    channel: 'Digital',
    region: 'Morocco',
    vendor: 'Google MENA',
    lastPurchasedRate: 3.90,
    benchmarkedRate: 4.50,
    variance: -13.3,
    performance: {
      cpm: 4.10,
      vtr: 68,
      completion: 71
    },
    audienceReach: 'Video Viewers 18-54',
    lastUpdated: '2024-02-03',
    category: 'Video Advertising',
    preferredVendor: true,
    availability: 'High'
  }
];

export const regions = [
  'All Regions',
  'Saudi Arabia',
  'UAE',
  'Egypt', 
  'Qatar',
  'Kuwait',
  'Iraq',
  'Morocco',
  'Jordan',
  'Oman',
  'Bahrain',
  'Lebanon',
  'Kazakhstan',
  'North Africa'
];

export const channels = [
  'All Channels',
  'TV',
  'Digital',
  'Print',
  'Radio',
  'Outdoor'
];

export const vendors = [
  'All Vendors',
  'MBC Group',
  'Google MENA',
  'Meta MENA',
  'Al Khaleej Newspapers',
  'Dubai FM Network',
  'Hypermedia Qatar',
  'Saudi Broadcasting',
  'Gulf Outdoor Media'
];